import { legalMachine } from '~/machines/legal-completion';
import { solarMachine } from '~/machines/solar-funnel';
import { fetchVnmTerms } from '~/services';
import { fetchContractLanguage } from '~/utils/fetch-contract-language';
import { getInitialState } from '~/utils/funnels';
import { communityHousingPartnersRedirects } from '~/utils/redirects';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    utility: {
      context: { redirect: communityHousingPartnersRedirects },
    },
  }).withConfig({
    services: {
      legalMachine: legalMachine().withConfig({
        services: {
          fetchTerms: async context => {
            const terms = await fetchVnmTerms({
              stateId: context.funnelPacket.utility.state.id,
              utilityAccountId: context.funnelPacket.utilityAccount.id,
            });

            terms.vnmSolarProjectContracts = terms.vnmSolarProjectContracts.filter(
              contract => contract.contractId !== 30,
            );
            const { docuSignContracts, showLmi, generalContracts, vnmSolarProjectContracts } =
              terms;
            const allSolarContracts = generalContracts
              ? vnmSolarProjectContracts?.concat(generalContracts)
              : vnmSolarProjectContracts;

            const unsignedSolarContracts = allSolarContracts?.filter(
              contractVersion =>
                !context.funnelPacket?.signedContractIds.includes(contractVersion.contractId),
            );
            return fetchContractLanguage(docuSignContracts, unsignedSolarContracts, showLmi);
          },
        },
      }),
      // eslint-disable-next-line require-await, @typescript-eslint/no-unused-vars
      fetchBillingExperienceOptions: async _context => {
        return { billingExperienceOptions: ['ucb'] };
      },
    },
  });
